import { observer } from 'mobx-react-lite';
import React, { useEffect } from 'react';
import { TabPanel } from 'react-tabs';
import { colors } from '../../../../../../../../colorVars';
import { updatePlugins } from '../../../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/updatePlugins';
import { useWebsocketStore } from '../../../../../../../../stores/websocketStore/websocketProvider';
import { MultiSwitch } from '../../../../../../../atomic/buttons/multiSwitch/MultiSwitch';
import { EditableTableField } from '../../../../../../../atomic/inputs/editableTableField/EditableTableField';
import { TableSelect } from '../../../../../../../atomic/inputs/tableSelect/TableSelect';
import { Body3 } from '../../../../../../../atomic/text/Text';
import { IndividualPanelHeader } from '../IndividualPanelHeader';
import style from '../IndividualTacticStyle.module.css';

export const MfeRetracementTacticPanel = observer(
  // eslint-disable-next-line no-unused-vars
  ({ tradePlanId, addTab, ...rest }) => {
    const { tradePlanStore } = useWebsocketStore();
    const tradePlan = tradePlanStore.tradePlans[tradePlanId];
    const tacticId = tradePlan.exitTactics['MFE_RETRACEMENT']?.tacticId ?? null;
    const inPosition = tradePlan?.inPosition ?? null;
    const softOrder = tradePlanStore.softOrdersById[tacticId] ?? null;
    const mfeType = tradePlan?.exitTactics['MFE_RETRACEMENT']?.mfeType ?? null;
    const pnlSetting =
      tradePlan?.exitTactics['MFE_RETRACEMENT']?.activateSetting ?? null;
    const pnlType = tradePlan?.exitTactics['MFE_RETRACEMENT']?.pnlType ?? null;
    const activationAmount =
      tradePlan?.exitTactics['MFE_RETRACEMENT']?.activationValue ?? null;
    const retracePct =
      tradePlan?.exitTactics['MFE_RETRACEMENT']?.retracePct ?? null;

    // useEffect(() => {
    //   if (mfeType === 'byPositionPrice')
    //     updateTactic('activateSetting', 'PERCENT');
    // }, [mfeType]);

    const updateTactic = (field, newValue) => {
      updatePlugins(
        'tactic',
        { [field]: newValue },
        'MFE_RETRACEMENT',
        tradePlanId,
        null
      );
    };

    return (
      <TabPanel {...rest}>
        <div className={style.tableContainer}>
          <table className={style.table}>
            <IndividualPanelHeader />
            {inPosition && softOrder ? (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Activation Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    {pnlSetting === 'AMOUNT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        $
                      </Body3>
                    ) : null}
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        pnlSetting === 'PERCENT'
                          ? Number(activationAmount) * 100
                          : activationAmount
                      }
                      updateValue={(newValue) =>
                        updateTactic(
                          'activationValue',
                          pnlSetting === 'PERCENT'
                            ? Number(newValue) / 100
                            : newValue
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    {pnlSetting === 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Retrace %
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={Number(retracePct) * 100}
                      updateValue={(newValue) =>
                        updateTactic('retracePct', Number(newValue) / 100)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Current Max
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {`${Number(softOrder.value.tacticValue.maxMfe).toFixed(
                        2
                      )}${mfeType === 'byPnl' ? '(PnL)' : ''}`}
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Current Activation
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {`${Number(
                        softOrder.value.tacticValue.activateMfe
                      ).toFixed(2)}${mfeType === 'byPnl' ? '(PnL)' : ''}`}
                    </Body3>
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Current Retrace
                    </Body3>
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      {`${Number(
                        softOrder.value.tacticValue.retraceFromMfe
                      ).toFixed(2)}${mfeType === 'byPnl' ? '(PnL)' : ''}`}
                    </Body3>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            ) : (
              <tbody>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      MFE Type
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <MultiSwitch
                      margin="6px 0 0 0"
                      labels={['Position', 'PnL']}
                      values={['byPositionPrice', 'byPnl']}
                      controlledValue={mfeType}
                      setValue={(value) => updateTactic('mfeType', value)}
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Activation Setting
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <TableSelect
                      // disabled={mfeType === 'byPositionPrice'}
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      value={pnlSetting}
                      onChange={(newValue) =>
                        updateTactic('activateSetting', newValue)
                      }
                      options={[
                        { label: 'Percent', value: 'PERCENT' },
                        { label: 'Dollars', value: 'AMOUNT' },
                      ]}
                    />
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3
                      fontWeight={700}
                      color={
                        mfeType === 'byPositionPrice'
                          ? 'gray'
                          : colors.lightGrey
                      }
                    >
                      PnL Type
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <TableSelect
                      disabled={mfeType === 'byPositionPrice'}
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                      value={pnlType}
                      onChange={(newValue) => updateTactic('pnlType', newValue)}
                      options={[
                        { label: 'Overall', value: 'OVERALL' },
                        { label: 'Unrealized', value: 'UNREALIZED' },
                      ]}
                    />
                  </td>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Activation Amount
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    {pnlSetting === 'AMOUNT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        $
                      </Body3>
                    ) : null}
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={
                        pnlSetting === 'PERCENT'
                          ? Number(activationAmount) * 100
                          : activationAmount
                      }
                      updateValue={(newValue) =>
                        updateTactic(
                          'activationValue',
                          pnlSetting === 'PERCENT'
                            ? Number(newValue) / 100
                            : newValue
                        )
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />
                    {pnlSetting === 'PERCENT' ? (
                      <Body3
                        fontWeight={700}
                        color={colors.lightGrey}
                        margin="3px 3px 0 0"
                      >
                        %
                      </Body3>
                    ) : null}
                  </td>
                </tr>
                <tr>
                  <td className={style.labelTd}>
                    <Body3 fontWeight={700} color={colors.lightGrey}>
                      Retrace %
                    </Body3>
                  </td>
                  <td className={style.inputTd}>
                    <EditableTableField
                      inputType="number"
                      bodySize={3}
                      initialValue={Number(retracePct) * 100}
                      updateValue={(newValue) =>
                        updateTactic('retracePct', Number(newValue) / 100)
                      }
                      color={colors.lightGrey}
                      backgroundColor="inherit"
                    />

                    <Body3
                      fontWeight={700}
                      color={colors.lightGrey}
                      margin="3px 3px 0 0"
                    >
                      %
                    </Body3>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </tbody>
            )}
          </table>
        </div>
      </TabPanel>
    );
  }
);

MfeRetracementTacticPanel.tabsRole = 'TabPanel';
